import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { ReactComponent as Logo } from "@/assets/musio-logos/logo_center_top.svg";
import { Button } from "@/components/ui/button";
import { useLocation } from "wouter";

export default function ConfirmEmailPage() {
  const [_, navigate] = useLocation();

  return (
    <div className="flex flex-col items-center justify-center font-inter space-y-2">
      <div className="w-[128px] h-[128px] flex-shrink-0 flex justify-center items-center">
        <Logo />
      </div>
      <Card className="p-4 flex space-y-4 items-center justify-center flex-col musio-glass w-full max-w-[478px]">
        <CardHeader className="w-full">
          <CardTitle className="font-semibold text-3xl text-center font-inter">Account Created!</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-2 w-full text-center">
            <p
              className="center text-musio-text-light text-sm peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Check your email and click the verify link we sent you.
            </p>
          </div>
        </CardContent>
        <CardFooter className="w-full">
          <Button
            type="button"
            className="w-full border-primary bg-musio-green font-bold text-musio-mid-gray border-none"
            variant="outline"
            onClick={e => {
              e.preventDefault();
              navigate("~/login");
            }}
          >
            Return
          </Button>
        </CardFooter>
      </Card>
    </div>
  )
}
